import React, { Component } from "react";
import lFilter from "lodash/filter";
import sortBy from "lodash/sortBy";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import CircularProgress from "@mui/material/CircularProgress";
import TooltipCustom from "../../atoms/tooltipCustom";
import avatarSvg from "assets/image/icons/svg/user.svg";
import "./style.scss";
import { contactsPageSize } from "../../../api/contactsPageSize";
import { connect } from "react-redux";
import { executionsUtils } from "features/executions";

import clsx from "clsx";
import { Actions } from "./Actions";

export class TableActivity extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 0,
      rowsPerPage: contactsPageSize.get(),
      contactsOnPage: [],
      selected: [],
      selectedOnPage: [],
      filterRows: [],
      scrollBarWidth: false,
    };
    this.wrapper = React.createRef();
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
    this.setState({
      contactsOnPage: this.getContactsOnPage(this.state.page),
    });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  componentDidUpdate() {
    const scrollbarWidth =
      this.wrapper.current.offsetWidth - this.wrapper.current.clientWidth;

    if (scrollbarWidth > 0 && this.state.scrollBarWidth === false) {
      this.setState({ scrollBarWidth: true });
    }

    if (scrollbarWidth === 0 && this.state.scrollBarWidth === true) {
      this.setState({ scrollBarWidth: false });
    }
  }

  handleResize = () => {
    const scrollbarWidth =
      this.wrapper.current.offsetWidth - this.wrapper.current.clientWidth;

    if (scrollbarWidth > 0 && this.state.scrollBarWidth === false) {
      this.setState({ scrollBarWidth: true });
    }

    if (scrollbarWidth === 0 && this.state.scrollBarWidth === true) {
      this.setState({ scrollBarWidth: false });
    }
  };

  getContactsOnPage = (page) => {
    const newContacts = this.props.contacts.activity.filter(
      (item, index) =>
        this.state.rowsPerPage * page <= index &&
        index < this.state.rowsPerPage * (page + 1)
    );
    return newContacts.map((item) => item.id);
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({
      page: 0,
      rowsPerPage: parseInt(event.target.value, 10),
    });
  };

  Sort = () => {
    this.setState({
      rows: sortBy(this.props.contacts.activity, [
        function (o) {
          return o.name;
        },
      ]),
    });
  };

  Filter = () => {
    this.setState({
      rows: lFilter(this.props.contacts.activity, { status: 1 }),
    });
  };

  handleClick = (event, name) => {
    const selectedIndex = this.state.selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(this.state.selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(this.state.selected.slice(1));
    } else if (selectedIndex === this.state.selected.length - 1) {
      newSelected = newSelected.concat(this.state.selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        this.state.selected.slice(0, selectedIndex),
        this.state.selected.slice(selectedIndex + 1)
      );
    }
    this.setState({
      selected: newSelected,
    });
  };

  isSelected = (name) => this.state.selected.indexOf(name) !== -1;

  onSelectAllPageClick = (event) => {
    if (event.target.checked) {
      let newSelecteds = this.getContactsOnPage(this.state.page);
      newSelecteds = newSelecteds.filter(
        (item) => !this.state.selected.includes(item)
      );
      this.setState({
        selected: this.state.selected.concat(newSelecteds),
      });
      return;
    }
    this.setState({
      selected: this.state.selected.filter(
        (item) => !this.state.contactsOnPage.includes(item)
      ),
    });
  };

  onSelectAllClick = () => {
    const newSelecteds = this.props.contacts.activity.map((item) => item.id);
    this.setState({
      selected: newSelecteds,
    });
  };

  clearCheckboxes = () => this.setState({ selected: [] });

  findColor = (state) => {
    switch (state) {
      case "findColor":
        return "red";

      default:
        break;
    }
  };

  renderSteps = (row, item) => {
    const items = [];
    for (const index in row) {
      row[index].is_visible &&
        items.push(
          <TooltipCustom key={index} title={row[index].hint} arrow={true}>
            <div
              className={`steps-container-item`}
              style={{
                background: `${executionsUtils.colorByStep(
                  item.human_state,
                  row[index]
                )}`,
              }}
            />
          </TooltipCustom>
        );
    }

    return items;
  };

  buildStartIn = (value) => {
    if (value === 0) {
      return "processing";
    }
    if (value < 60) {
      return `${value} min`;
    }

    if (value >= 60 && value < 1440) {
      const getHours = Math.floor(value / 60);
      const lastMinute = value - getHours * 60;
      const hourName = getHours > 1 ? "hours" : "hour";

      return `${getHours}${" "} ${hourName} ${
        lastMinute > 0 ? `${lastMinute} min` : ""
      }`;
    }

    if (value > 1440) {
      const getDays = Math.floor(value / 1440);
      const lastHour = Math.floor((value - getDays * 1440) / 60);
      const lastMinute = value - getDays * 1440 - lastHour * 60;
      const hourName = lastHour > 1 ? "hours" : "hour";

      return `${getDays > 1 ? `${getDays} days` : `${getDays} day`} ${
        lastHour > 0 ? `${lastHour} ${" "} ${hourName}` : ""
      }  ${lastMinute > 0 ? `${lastMinute} min` : ""}`;
    }

    return value;
  };

  render() {
    return (
      <div
        className={`table-container ${this.props.classesContainer}`} /*className={`table-container ${this.props.classesContainer} ${
        this.props.contacts.total &&
        this.props.contacts.total > this.state.rowsPerPage
          ? "table-with-footer"
          : ""
      }`}*/
      >
        <TableContainer
          className={
            this.props.checkboxs &&
            (!this.props.campaignStatus ||
              this.props.campaignStatus === "Compose")
              ? "table-body with-checkboxs"
              : "table-body single-contacts"
          }
        >
          {this.props.app.tableContentLoader &&
            !this.props.app.pageContentLoader && (
              <div className="table-material-loader-wrapper">
                <CircularProgress
                  color="primary"
                  size={60}
                  classes={{ colorPrimary: "material-loader" }}
                />
              </div>
            )}
          <Table
            className={"table users"}
            size="small"
            aria-label="a dense table"
          >
            <TableHead>
              <TableRow>
                <TableCell className="name-activities">
                  {this.state.selected.length > 0 ? (
                    <div className="selected-rows">
                      {this.state.selected.length ===
                      this.props.contacts.activity.length ? (
                        <>
                          <span className="select-text">
                            {this.state.selected.length} selected |{" "}
                          </span>
                          <span
                            className="clear-all"
                            onClick={this.clearCheckboxes}
                          >
                            Clear
                          </span>
                        </>
                      ) : (
                        <>
                          <span className="select-text">
                            {this.state.selected.length} of{" "}
                            {this.props.contacts.activity.length} selected |{" "}
                          </span>
                          <span
                            className="clear-all"
                            onClick={this.onSelectAllClick}
                          >
                            Select all
                          </span>
                        </>
                      )}
                    </div>
                  ) : (
                    "Contact"
                  )}
                </TableCell>
                {/* <TableCell className="company">Company</TableCell> */}
                <TableCell className="campaign">Campaign</TableCell>
                <TableCell className="activity">Activity</TableCell>

                <TableCell className="steps">Status</TableCell>

                <TableCell className="started">Starts In</TableCell>
              </TableRow>
            </TableHead>
            <TableBody
              ref={this.wrapper}
              className={clsx(
                "app-scroll",
                this.props.campaignsCount > this.state.rowsPerPage
                  ? "table-with-footer-activities"
                  : "table-with-out-footer-activities"
              )}
            >
              {this.props.contacts.activity
                // .slice(
                //   this.state.page * this.state.rowsPerPage,
                //   this.state.page * this.state.rowsPerPage +
                //     this.state.rowsPerPage
                // )
                .map((row, index) => (
                  <TableRow key={row.id} className="row">
                    <TableCell className="name-activities">
                      <div className="name-container">
                        <img
                          className="avatar"
                          src={row.avatar ? row.avatar : avatarSvg}
                          alt="avatar"
                        />
                        <div className="profile text-box-wrapper">
                          <div className="text-page first-name semi-bold ellipsis">
                            {row.fullName}
                          </div>
                        </div>
                      </div>
                    </TableCell>
                    <TableCell className="text-page campaign regular">
                      <div className="text-box-wrapper">
                        {row.campaign_name}
                      </div>
                    </TableCell>
                    <TableCell className={`text-page activity regular`}>
                      <div className="text-box-wrapper">{row.activity}</div>
                    </TableCell>
                    <TableCell className="steps">
                      <div className="steps-container">
                        {this.renderSteps(row.campaignExecutions, row)}
                      </div>
                    </TableCell>
                    <TableCell
                      className="started"
                      style={{
                        width: this.state.scrollBarWidth ? "19%" : "20%",
                      }}
                    >
                      <div className="start-wrapper">
                        <div className="start-end-date">
                          {this.buildStartIn(row.start_in)}
                        </div>
                        <Actions
                          activities={this.props.contacts.activity}
                          item={row}
                          index={index}
                        />
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        {/* <div className="table-footer">
          <PaginationWrapper
            component="div"
            rowsPerPageOptions={[]}
            count={this.props.contacts.total}
            rowsPerPage={this.state.rowsPerPage}
            page={this.state.page}
            onPageChange={this.handleChangePage}
          />
        </div> */}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  app: state.app,
  contacts: state.activity,
});

export default connect(mapStateToProps)(TableActivity);
